<template>
    <span v-if="errors.length > 0" class="md-error">{{ errors[0] }}</span>
</template>
<script>
    export default {
        name: 'ServerError',
        props: {
            serverErrors: {
                type: Object,
                required: true
            },
            fieldName: {
                type: String,
                required: true
            }
        },
        computed: {
            errors: {
                get() {
                    return [].concat(_.get(this.serverErrors, this.fieldName, []));
                }
            }
        }
    }
</script>
